import { C, S } from '../constants';
import { fmtUAH } from '../utils';

export function Badge({ color, children }) {
  return <span style={S.badge(color)}>{children}</span>;
}

export function StatusBadge({ label, statusName }) {
  const c = label === "successful" ? C.green : label === "cancelled" ? C.pink : C.yellow;
  const fallback = label === "successful" ? "Успішне" : label === "cancelled" ? "Відмінено" : "В обробці";
  return <Badge color={c}>{statusName || fallback}</Badge>;
}

export function ProductStatusBadge({ status }) {
  if (status === "active") return <Badge color={C.green}>Активний</Badge>;
  if (status === "out_of_stock") return <Badge color={C.yellow}>Немає в наявн.</Badge>;
  return <Badge color={C.text3}>Архівний</Badge>;
}

export function FfBadge({ isFf }) {
  return <Badge color={isFf ? C.purple : C.green}>{isFf ? "FF" : "FBS"}</Badge>;
}

export function AbcBadge({ cls }) {
  const c = cls === "A" ? C.green : cls === "B" ? C.yellow : C.pink;
  return <Badge color={c}>{cls}</Badge>;
}

export function DaysBadge({ days }) {
  if (!days) return <span style={{ color: C.text4 }}>-</span>;
  const c = days <= 7 ? C.pink : days <= 30 ? C.yellow : C.green;
  const label = days <= 7 ? `${days}д ⚠` : `${days}д`;
  return <Badge color={c}>{label}</Badge>;
}

export function ProfitBadge({ profit, hasCost }) {
  if (!hasCost) return <span style={{ color: C.text4, fontSize: 12 }}>немає собів.</span>;
  const c = profit >= 0 ? C.green : C.pink;
  return <Badge color={c}>{profit >= 0 ? "+" : ""}{fmtUAH(profit)}</Badge>;
}
